module.exports = __webpack_public_path__ + "static/media/cover-ads.db39a9cf.png";